import * as actionType from "./ActionTypes";
import { findIndex, sumBy } from "lodash";

export default function aggregateBookingReducer(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case actionType.AGGREGATE_BOOKING_LOADED:
      return (state = payload);

    case actionType.AGGREGATE_BOOKING_DONE:
      var bookedShipment = {
        ...state[payload.Country],
      };
      const findId = findIndex(bookedShipment.subRows, (data) => {
        return (
          data.DailyContainerPlanningAggregateId ===
          payload.DailyContainerPlanningAggregateId
        );
      });
      bookedShipment.subRows[findId] = {
        ...bookedShipment.subRows[findId],
        Country: payload["Country"],
        Booking_Number: payload["BookingNo"],
        AssignContainerAggregateId: payload["AssignContainerAggregateId"],
      };
      return {
        ...state,
        [`${payload.Country}`]: bookedShipment,
      };

    case actionType.AGGREGATE_BOOKING_UPDATED:
      var approvedShipmentBooking = {
        ...state[payload.Country],
      };
      for (const item of approvedShipmentBooking.subRows) {
        if (
          item["AssignContainerAggregateId"] ===
          payload["AssignContainerAggregateId"]
        ) {
          const indexOfItem = approvedShipmentBooking.subRows.indexOf(item);
          approvedShipmentBooking.subRows[indexOfItem] = {
            ...item,
            Booking_Number: payload["BookingNo"],
          };
          break;
        }
      }
      return {
        ...state,
        [`${payload.Country}`]: approvedShipmentBooking,
      };

    case actionType.AGGREGATE_BOOKING_SENT_FOR_APPROVAL:
      var shipmentForApproval = {
        ...state[payload.Country],
      };
      const findApprovedId = findIndex(shipmentForApproval.subRows, (data) => {
        return (
          data.DailyContainerPlanningAggregateId ===
          payload.DailyContainerPlanningAggregateId
        );
      });
      if (payload.Reason === "" && payload.manualReason !== "") {
        shipmentForApproval.subRows[findApprovedId] = {
          ...shipmentForApproval.subRows[findApprovedId],
          AssignContainerAggregateId: payload.AssignContainerAggregateId,
          Reason: `${payload.manualReason}`,
          STATUS: "Pending",
        };
      } else if (payload.Reason !== "" && payload.manualReason !== "") {
        shipmentForApproval.subRows[findApprovedId] = {
          ...shipmentForApproval.subRows[findApprovedId],
          AssignContainerAggregateId: payload.AssignContainerAggregateId,
          Reason: `${payload.Reason},${payload.manualReason}`,
          STATUS: "Pending",
        };
      } else {
        shipmentForApproval.subRows[findApprovedId] = {
          ...shipmentForApproval.subRows[findApprovedId],
          AssignContainerAggregateId: payload.AssignContainerAggregateId,
          Reason: payload.Reason,
          STATUS: "Pending",
        };
      }

      return {
        ...state,
        [`${payload.Country}`]: shipmentForApproval,
      };

    case actionType.AGGREGATE_BOOKING_STATUS_UPDATE_FROM_JD:
      var jdResponseOnShipment = {
        ...state[payload.Country],
      };
      const findStatusIdFromJD = findIndex(
        jdResponseOnShipment.subRows,
        (data) => {
          return (
            data.DailyContainerPlanningAggregateId ===
            payload.DailyContainerPlanningAggregateId
          );
        }
      );
      jdResponseOnShipment.subRows[findStatusIdFromJD] = {
        ...jdResponseOnShipment.subRows[findStatusIdFromJD],
        STATUS: payload.DeereStatus,
      };
      return {
        ...state,
        [`${payload.Country}`]: jdResponseOnShipment,
      };

    case actionType.AGGREGATE_PLANNING_DONE:
      var plannedShipment = {
        ...state[payload.Country],
      };
      for (const item of plannedShipment.subRows) {
        if (
          item.Booking_Number === payload.Booking_Number &&
          item.AssignContainerId === payload.AssignContainerId
        ) {
          const indexOfItem = plannedShipment.subRows.indexOf(item);
          plannedShipment.subRows[indexOfItem] = {
            ...item,
            Container_Number: payload.Container_Number,
          };
          break;
        }
      }
      return {
        ...state,
        [`${payload.Country}`]: plannedShipment,
      };

    case actionType.AGGREGATE_COLUMN_UPDATED:
      var updatedDataShipment = {
        ...state[payload.Country],
      };
      const findInsertedDataId = findIndex(
        updatedDataShipment.subRows,
        (data) => {
          return (
            data.DailyContainerPlanningAggregateId ===
            payload.DailyContainerPlanningAggregateId
          );
        }
      );
      if(findInsertedDataId >= 0){
        updatedDataShipment.subRows[findInsertedDataId] = {
          ...updatedDataShipment.subRows[findInsertedDataId],
          [payload.ColumnName]: payload.Value,
        };
      }
      return {
        ...state,
        [`${payload.Country}`]: updatedDataShipment,
      };

    case actionType.AGGREGATE_COLUMN_UPDATED_FOR_INSPECTION:
      var updatedShipmentForInspection = {
        ...state[payload.Country],
        [`${payload.ColumnName}`]: payload.Value,
      };
      var updatedSubRowsForInspection = [];
      for (let i = 0; i < updatedShipmentForInspection.subRows.length; i++) {
        updatedSubRowsForInspection.push({
          ...updatedShipmentForInspection.subRows[i],
          [`${payload.ColumnName}`]: `${payload.Value}`,
        });
      }
      return {
        ...state,
        [`${payload.Country}`]: {
          ...updatedShipmentForInspection,
          subRows: updatedSubRowsForInspection,
        },
      };

    case actionType.AGGREGATE_INSERT_DROPDOWN_DATA:
      var updatedPODShipment = {
        ...state[payload.Country],
      };
      const findInsertedPODId = findIndex(
        updatedPODShipment.subRows,
        (data) => {
          return (
            data.DailyContainerPlanningAggregateId ===
            payload.DailyContainerPlanningAggregateId
          );
        }
      );
      updatedPODShipment.subRows[findInsertedPODId] = {
        ...updatedPODShipment.subRows[findInsertedPODId],
        [payload.ColumnName]: payload.Value,
      };
      return {
        ...state,
        [`${payload.Country}`]: updatedPODShipment,
      };

    case actionType.AGGREGATE_DELETE_SUBROW:
      // if(payload.deleteIdPayload.length === 0){
        payload.statePayload(payload.deleteIdPayload)
      // }
      return (state = payload.deleteIdPayload);
    
      case actionType.AGGREGATE_UPDATE_BOOKING_NO:
        var updateBookingNo = {
          ...state[payload.Country]
        }
        const findUpdatedBookingNoId = findIndex(
          updateBookingNo.subRows,
          (data) => {
            return (
              data.DailyContainerPlanningAggregateId === payload.DailyContainerPlanningAggregateId
            );
          }
        );
        if(payload.bookingNo !== ""){
          updateBookingNo.subRows[findUpdatedBookingNoId] = {
            ...updateBookingNo.subRows[findUpdatedBookingNoId],
            Booking_Number: payload.bookingNo,
          };
        }else{
          updateBookingNo.subRows[findUpdatedBookingNoId] = {
            ...updateBookingNo.subRows[findUpdatedBookingNoId],
            Booking_Number: payload.bookingNo,
          };
        }
        return {
          ...state,
          [`${payload.Country}`]: updateBookingNo,
        };

      case actionType.AGGREGATE_UPDATE_BOOKING_QTY:
        var updateQty = {
          ...state[payload.Country]
        }
        var arr = []
        const findUpdatedQtyId = findIndex(
          updateQty.subRows,
          (data) => {
            return (
              data.DailyContainerPlanningAggregateId === payload.DailyContainerPlanningAggregateId
            );
          }
        );
        updateQty.subRows[findUpdatedQtyId] = {
          ...updateQty.subRows[findUpdatedQtyId],
          Quantity : payload.Quantity
        }
        for (let i = 0; i < updateQty.subRows.length; i++) {
          arr.push(updateQty.subRows[i].Quantity)
        }
        let QtySummation = (sumBy(arr, function(o){return parseInt(o)}));
        updateQty.Quantity = QtySummation
        return {
          ...state,
          [payload.Country] : updateQty
        }
  
      case actionType.AGGREGATE_UPDATE_BOOKING_CONTAINER_QTY:
        var updateContainerQty = {
          ...state[payload.Country]
        }
        var arrs = []
        const findUpdatedContainerQtyId = findIndex(
          updateContainerQty.subRows,
          (data) => {
            return (
              data.DailyContainerPlanningAggregateId === payload.DailyContainerPlanningAggregateId
            );
          }
        );
        updateContainerQty.subRows[findUpdatedContainerQtyId] = {
          ...updateContainerQty.subRows[findUpdatedContainerQtyId],
          Container_Count : payload.Container_Count
        }
        for (let i = 0; i < updateContainerQty.subRows.length; i++) {
          arrs.push(updateContainerQty.subRows[i].Container_Count)
        }
        let ContainerQtySummation = (sumBy(arrs, function(o){return parseInt(o)}));
        updateContainerQty.Container_Count = ContainerQtySummation
        return {
          ...state,
          [payload.Country] : updateContainerQty
        }
    default:
      return state;
  }
}
